import type { RouteObject } from "react-router-dom";
import { page } from "@/app/page";
import { RequireTenantAdmin } from "@/app/guards";

export const supportRoutes: RouteObject[] = [
  { id: "support.mine", path: "/support/my-tickets", element: page(() => import("@/screens/support/MyTickets")) },
  { id: "support.mine.detail", path: "/support/my-tickets/:id", element: page(() => import("@/screens/support/MyTicketDetail")) },
  // Admin-only, as before; the backend's admin middleware is the real authority.
  { id: "support.inbox", path: "/support/inbox", element: <RequireTenantAdmin>{page(() => import("@/screens/support/AdminInbox"))}</RequireTenantAdmin> },
  { id: "support.vendor", path: "/support/vendor", element: <RequireTenantAdmin>{page(() => import("@/screens/support/VendorTickets"))}</RequireTenantAdmin> },
  { id: "support.vendor.detail", path: "/support/vendor/:id", element: <RequireTenantAdmin>{page(() => import("@/screens/support/VendorTicketDetail"))}</RequireTenantAdmin> },
];
